import React, { useEffect } from "react";
import { usePainelPublico } from "../../../hooks/usePainelPublico";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { actionGetAlertasAbertosPublico } from "../../../features/(ApiKey)/alertas/get/slices";
import "./style.scss";
import { LoaderCircle } from "lucide-react";

const PagePainelPublico = () => {
  const dispatch = useAppDispatch();
  const { apiKey, status, revogarAcesso, data } = usePainelPublico();
  const alertas = useAppSelector((state) => state.getAlertasAbertosPublico);

  useEffect(() => {
    if (status !== "ready" || !apiKey) return;

    const fetch = () => {
      dispatch(
        actionGetAlertasAbertosPublico({ idLoja: 0, idCliente: 1, apiKey }),
      );
    };

    fetch();

    const interval = setInterval(fetch, 30000);
    return () => clearInterval(interval);
  }, [status, apiKey, dispatch]);

  if (status === "loading") {
    return <div>Carregando painel...</div>;
  }

  if (status === "unauthorized") {
    return (
      <div
        className="center-object-screen"
        style={{
          flexDirection: "column",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <h2>Acesso não autorizado</h2>
        <p>
          Link inválido ou expirado. Solicite um novo link ao administrador.
        </p>
      </div>
    );
  }

  if (alertas.status === "loading") {
    return (
      <div className="center-object-screen">
        <LoaderCircle className="loader" />
      </div>
    );
  }

  console.log("alertas.data", alertas.data);

  return (
    <div className="painel-publico">
      <div className="logos">
        {data &&
          data.logos.map((logoUrl: string, index: number) => (
            <img key={index} src={logoUrl} alt={`Logo ${index + 1}`} />
          ))}
      </div>
      <header className="painel-header">
        <h1 style={{ fontSize: "1.6rem", color: "#555" }}>Painel de Alertas</h1>
      </header>

      <div className="painel-grid">
        {alertas.data

          ?.filter((alerta: any) => {
            const desc = alerta.descricao.toLowerCase();
            return (
              !desc.includes("encontra-se offline") &&
              !desc.includes("módulo") &&
              !desc.includes("central id:")
            );
          })

          .map((alerta: any) => (
            <div
              key={alerta.id}
              className={`alerta-card ${
                alerta.status === "Em Andamento"
                  ? "alerta-laranja"
                  : alerta.status === "Ok"
                    ? "alerta-verde"
                    : alerta.status === "Normalizado/Aguardando Plano de Ação"
                      ? "alerta-verde"
                      : alerta.status === "Normalizado/Não Reconhecido"
                        ? "alerta-verde"
                        : alerta.status === "Não Reconhecido"
                          ? "alerta-vermelho"
                          : alerta.status === "Aguardando Plano de Ação"
                            ? "alerta-vermelho"
                            : alerta.status === "Atuado/Reconhecido"
                              ? "alerta-vermelho"
                              : alerta.status === "Prazo Excedido"
                                ? "alerta-vermelho"
                                : "alerta-desconhecido"
              }`}
            >
              <div className="alerta-header">
                <span className="loja-nome">{alerta.loja.nome}</span>
                <span className="alerta-id">Id: {alerta.id}</span>
              </div>

              <div className="alerta-body">
                <p className="descricao">{alerta.descricao}</p>
              </div>

              <div className="alerta-footer">
                <span>
                  {new Date(alerta.dataEvento).toLocaleDateString("pt-BR")}
                </span>
                <span className="status-badge">{alerta.status}</span>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default PagePainelPublico;
